import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { DefaultWaveSmallLeaderboardDrop } from "./DefaultWaveSmallLeaderboardDrop";
interface QuorumWaveSmallLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: () => void;
}
export const QuorumWaveSmallLeaderboardDrop: React.FC<QuorumWaveSmallLeaderboardDropProps> = t0 => {
  const $ = _c(3);
  const {
    drop,
    onDropClick
  } = t0;
  let t1;
  if ($[0] !== drop || $[1] !== onDropClick) {
    t1 = <DefaultWaveSmallLeaderboardDrop drop={drop} onDropClick={onDropClick} contentPresentation="quorumCompact" />;
    $[0] = drop;
    $[1] = onDropClick;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};